import React from "react";
import { Link } from "react-router-dom";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import InsightsIcon from '@mui/icons-material/Insights';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import QRTlogo from "../../images/favicon_QRT_white.png";
import { useMediaQuery, Drawer, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import axios from "axios";

import { useState, useEffect } from "react";
import { API_URL } from "../../api-config";

function Topbar({ token, setToken }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [anchorElUSD, setAnchorElUSD] = React.useState(null);
    const [anchorElDataChile, setAnchorElDataChile] = React.useState(null);
    const [anchorElLatam, setAnchorElLatam] = React.useState(null);
    const [anchorElManager, setAnchorElManager] = React.useState(null);
    const [anchorElPriceFeed, setAnchorElPriceFeed] = React.useState(null);
    const openDataChile = Boolean(anchorElDataChile);
    const openUSD = Boolean(anchorElUSD);
    const openLatam = Boolean(anchorElLatam);
    const openManager = Boolean(anchorElManager);
    const openPriceFeed = Boolean(anchorElPriceFeed);
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const isMobile = useMediaQuery('(max-width:600px)');
    const [admin, setAdmin] = useState(false);
    // const [tester,setTester] = useState(false);
    const [isManager, setIsManager] = useState(false);
    useEffect(() => {
        if (token === null) {
            return;
        }
        axios.get(`${API_URL}/users-api/me`, {
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + token,
            }
        }).then((response) => {
            let roles = response.data.roles;
            console.log("Roles ", roles)
            if (roles.includes("Admin")) {
                setAdmin(true);
            }
            // if (roles.includes("Tester")) {
            //     setTester(true);
            // }
            if (roles.includes("Manager")) {
                setIsManager(true);
            }
        }).catch((error) => {
            // Verificar si el error es por un 401 Unauthorized
            if (error.response && error.response.status === 401) {
                localStorage.removeItem('token'); // Elimina el token
                window.location.href = '/'; // Redirige a la página de login
            } else {
                console.log(error); // Manejo de otros errores
            }
        });
    }, []);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClickUSD = (event) => {
        setAnchorElUSD(event.currentTarget);
    };
    const handleClickLatam = (event) => {
        setAnchorElLatam(event.currentTarget);
    };
    const handleClickManager = (event) => {
        setAnchorElManager(event.currentTarget);
    };
    const handleClickDataChile = (event) => {
        setAnchorElDataChile(event.currentTarget);
    };
    const handleClickPriceFeed = (event) => {
        setAnchorElPriceFeed(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseUSD = () => {
        setAnchorElUSD(null);
    };
    const handleCloseLatam = () => {
        setAnchorElLatam(null);
    };
    const handleCloseManager = () => {
        setAnchorElManager(null);
    };
    const handleCloseDataChile = () => {
        setAnchorElDataChile(null);
    };
    const handleClosePriceFeed = () => {
        setAnchorElPriceFeed(null);
    };
    const Logout = () => {
        window.location.assign("/");
        localStorage.removeItem("token");
        setToken(null);
    };
    const goTo = (string) => {
        window.location.assign(string);
    };

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const menuList = (
        <List>

            <ListItem button onClick={() => goTo("/")}>
                <ListItemIcon><HomeOutlinedIcon /></ListItemIcon>
                <ListItemText primary="Dashboard" />
            </ListItem>
            <ListItem button onClick={() => { handleClickDataChile }}>
                <ListItemIcon><InsightsIcon /></ListItemIcon>
                <ListItemText primary="Acciones Chilenas" />
            </ListItem>
            <Menu
                id="basic-menu"
                anchorEl={anchorElDataChile}
                open={openDataChile}
                onClose={handleCloseDataChile}
                MenuListProps={{ 'aria-labelledby': 'basic-button' }}
            >
                <MenuItem onClick={() => goTo("/chile")}>Acciones Chilenas</MenuItem>
            </Menu>
            <ListItem button onClick={handleClickUSD}>
                <ListItemIcon><LocalAtmIcon /></ListItemIcon>
                <ListItemText primary="USDCLP" />
            </ListItem>
            <Menu
                id="basic-menu"
                anchorEl={anchorElUSD}
                open={openUSD}
                onClose={handleCloseUSD}
                MenuListProps={{ 'aria-labelledby': 'basic-button' }}
            >
                <MenuItem onClick={() => goTo("/atr")}>Gráfico Interactivo</MenuItem>
                <MenuItem onClick={() => goTo("/atr_daily")}>Velas Diarias</MenuItem>
                <MenuItem onClick={() => goTo("/track_record")}>Proyecto Dólar Peso</MenuItem>
                <MenuItem onClick={() => goTo("/balanceador")}>Balanceador</MenuItem>
                <MenuItem onClick={() => goTo("/trades_sistema")}>Research</MenuItem>
            </Menu>
            <ListItem button onClick={handleClickPriceFeed}>
                <ListItemIcon><InsightsIcon /></ListItemIcon>
                <ListItemText primary="Price Feed" />
            </ListItem>
            <Menu
                id="basic-menu"
                anchorEl={anchorElPriceFeed}
                open={openPriceFeed}
                onClose={handleClosePriceFeed}
                MenuListProps={{ 'aria-labelledby': 'basic-button' }}
            >
                <MenuItem onClick={() => goTo("/price_feed")}>Price Feed</MenuItem>
                <MenuItem onClick={() => goTo("/price_monitor")}>Monitor de Precio</MenuItem>

            </Menu>
            <ListItem button onClick={handleClick}>
                <ListItemIcon><PersonOutlinedIcon /></ListItemIcon>
                <ListItemText primary="Perfil" />
            </ListItem>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ 'aria-labelledby': 'basic-button' }}
            >
                <MenuItem onClick={() => goTo("/users/me")}>Mi perfil</MenuItem>
                {!admin && (<MenuItem onClick={() => goTo("/admin_panel")}>Panel de administrador</MenuItem>)}
                <MenuItem onClick={Logout}>Salir</MenuItem>
            </Menu>
        </List>
    );

    return (
        <div id="header" className="flex  flex-col bg-[#101523] md:h-auto h-auto mb-0" style={{ borderBottom: "1px solid white" }}>

            {token ? (
                isMobile ? (
                    <div className="flex justify-end p-2 h-16 w-16">
                        <IconButton className="" edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
                            <MenuIcon className="h-12 w-16" />
                        </IconButton>
                        <Drawer anchor="top" open={drawerOpen} onClose={toggleDrawer(false)}>
                            {menuList}
                        </Drawer>
                    </div>
                ) : (
                    <div className="w-screen flex flex-row p-2 justify-between">
                        <div className="flex  h-auto justify-around mt-4 ">
                            <div className="h-auto rounded-sm flex  mr-2 flex-row hover:bg-[#28b1c5] hover:text-black selected:bg-[#28b1c5] p-2" onClick={() => goTo("/")}>
                                <HomeOutlinedIcon />
                                {/* <h1>Dashboard</h1> */}
                            </div>

                            <div className="h-auto rounded-sm flex flex-row hover:bg-[#28b1c5] hover:text-black selected:bg-[#28b1c5] p-2" id="basic-button" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClickUSD}>
                                <LocalAtmIcon />
                                <h1> USDCLP</h1>
                            </div>
                            <Menu id="basic-menu" anchorEl={anchorElUSD} open={openUSD} onClose={handleCloseUSD} MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                                <MenuItem onClick={() => goTo("/atr")}>Gráfico Interactivo</MenuItem>
                                <MenuItem onClick={() => goTo("/atr_daily")}>Velas Diarias</MenuItem>
                                <MenuItem onClick={() => goTo("/track_record")}>Proyecto Dólar Peso</MenuItem>
                                <MenuItem onClick={() => goTo("/balanceador")}>Balanceador</MenuItem>
                                <MenuItem onClick={() => goTo("/trades_sistema")}>Research</MenuItem>
                            </Menu>

                            {/* <div className="h-auto rounded-sm flex flex-row hover:bg-[#28b1c5] hover:text-black selected:bg-[#28b1c5] p-2 ml-4" id="basic-button" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClickPriceFeed}>
                                <InsightsIcon />
                                <h1> Price Feed</h1>
                            </div>
                            <Menu id="basic-menu" anchorEl={anchorElPriceFeed} open={openPriceFeed} onClose={handleClosePriceFeed} MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                                <MenuItem onClick={() => goTo("/price_feed")}>Price Feed</MenuItem>
                                <MenuItem onClick={() => goTo("/price_monitor")}>Monitor de Precio</MenuItem>
                            </Menu> */}


                            {admin && (<div className="h-auto rounded-sm flex flex-row hover:bg-[#28b1c5] hover:text-black selected:bg-[#28b1c5] p-2 ml-4" id="basic-button" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClickLatam}>
                                <LocalAtmIcon />
                                <h1> Utils</h1>
                            </div>)}
                            {isManager && (<div className="h-auto rounded-sm flex flex-row hover:bg-[#28b1c5] hover:text-black selected:bg-[#28b1c5] p-2 ml-4" id="basic-button"
                                aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClickManager}>
                                <ManageAccountsIcon />
                                <h1> Manager</h1>
                            </div>)}
                            <Menu id="basic-menu" anchorEl={anchorElLatam} open={openLatam} onClose={handleCloseLatam} MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                                <MenuItem onClick={() => goTo("/latam")}>Volumen</MenuItem>
                                <MenuItem onClick={() => goTo("/posts")}>Posts</MenuItem>
                                <MenuItem onClick={() => goTo("/smart_bands")}>Smart Bands</MenuItem>
                                {/* <MenuItem onClick={() => goTo("/no_residentes")}>No Residentes</MenuItem> */}
                                <MenuItem onClick={() => goTo("/indicadores")}>Indicadores</MenuItem>
                                <MenuItem onClick={() => goTo("/markov_components")}>Markov Components</MenuItem>

                            </Menu>
                            <Menu id="basic-menu" anchorEl={anchorElManager} open={openManager} onClose={handleCloseManager} MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                                {/* <MenuItem onClick={() => goTo("/spread")}>Spread</MenuItem> */}
                                {/* <MenuItem onClick={() => goTo("/spread/rules")}>Spread</MenuItem> */}
                                <MenuItem onClick={() => goTo("/trading-accounts")}>Reportes</MenuItem>
                                <MenuItem onClick={() => goTo("/indicator")}>GPT-Beta</MenuItem>
                                <MenuItem onClick={() => goTo("/fix-client")}>Fix Client</MenuItem>
                                <MenuItem onClick={() => goTo("/orderbook")}>Order Book</MenuItem>
                                <MenuItem onClick={() => goTo("/tick-control")}>Control de Precios & Stall</MenuItem>
                            </Menu>
                        </div>

                        <div className=" flex-col flex px-4 pt-2 pb-2">
                            <Link to="/" variant="h1" className="flex justify-center">
                                <img src={QRTlogo} className="w-16" alt="QRT logo" />
                            </Link>
                        </div>
                        <div className="h-auto rounded-sm px-12 flex mt-4 flex-row hover:bg-[#28b1c5] hover:text-black selected:bg-[#28b1c5] p-2" id="basic-button" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick}>
                            <PersonOutlinedIcon />
                            <h1>Perfil</h1>
                        </div>
                        <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose} MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                            <MenuItem className="" onClick={() => goTo("/users/me")}>Mi perfil</MenuItem>
                            {isManager && (<MenuItem onClick={() => goTo("/admin_panel")}>Agentes</MenuItem>)}
                            {isManager && (<MenuItem onClick={() => goTo("/users/panel")}>Panel de usuarios</MenuItem>)}
                            <MenuItem onClick={Logout}>Salir</MenuItem>
                        </Menu>
                    </div>
                )
            ) :
                <div className="md:w-screen  flex-col flex px-4 pt-2 pb-2">
                    <Link to="/" variant="h1" className="flex justify-center">
                        <img src={QRTlogo} className="w-16" alt="QRT logo" />
                    </Link>
                </div>}

        </div>
    );
}

export default Topbar;
